<div class="layout-column i-center c-center height-100 box-p20">
  <div class="skelton-loading-bar layout-column i-center">
    <p class="ft-heading mb-8 color-gray3">{{message}}</p>
    <span></span>
  </div>
</div>